import React from 'react';
import './loadingAnimation.scss';

const LoadingAnimation = ({ 
  variant = 'basic', 
  size = 'medium',
  color = '#007bff',
  className = '',
  ...props 
}) => {
  const renderDots = (count = 9) => {
    return Array.from({ length: count }, (_, index) => (
      <div 
        key={index} 
        className={`loading-dot${variant === 'random' ? '-random' : ''}`}
        style={{ backgroundColor: color }}
      />
    ));
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'loading-grid-small';
      case 'large':
        return 'loading-grid-large';
      case 'xsmall':
        return 'loading-grid-xsmall';
      default:
        return variant === 'random' ? 'loading-grid-random' : 'loading-grid';
    }
  };

  return (
    <div 
      className={`${getSizeClasses()} ${className}`}
      style={{ '--dot-color': color }}
      {...props}
    >
      {renderDots()}
    </div>
  );
};

export default LoadingAnimation;
